import { render, staticRenderFns } from "./OverheadLoader.vue?vue&type=template&id=808e985a&scoped=true"
import script from "./OverheadLoader.vue?vue&type=script&lang=js"
export * from "./OverheadLoader.vue?vue&type=script&lang=js"
import style0 from "./OverheadLoader.vue?vue&type=style&index=0&id=808e985a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e985a",
  null
  
)

export default component.exports